export function isCompanyInvoiceFilled(invoice?: { companyName?: string | null; nipNumber?: string | number | null } | null): boolean {
  const companyName = invoice?.companyName?.trim();
  const nip = String(invoice?.nipNumber ?? '').trim();
  return Boolean(companyName && nip);
}
